export default class HubUnauthorizedError extends Error {
  //
}
